import { useContext } from 'react';
import { ChatContext } from './ChatContext';

const EMPTY_CHAT = {
  me: null, channels: [], setChannels: () => {}, activeChannel: null,
  messages: [], typingUsers: {}, loading: false, totalUnread: 0,
  toasts: [], newMsg: '', uploading: false,
  showNewModal: false, setShowNewModal: () => {}, renameTarget: null, setRenameTarget: () => {},
  showMembers: false, setShowMembers: () => {}, requestChannelId: null, setRequestChannelId: () => {},
  meetingChannel: null, setMeetingChannel: () => {}, meetingOpen: false, setMeetingOpen: () => {},
  isInitialLoadRef: { current: false },
  selectChannel: () => {}, handleInputChange: () => {}, sendMessage: () => {}, handleFileSelect: () => {},
  createChannel: () => {}, renameChannel: () => {}, deleteChannel: () => {}, openDm: () => {},
  loadChannels: () => {}, dismissToast: () => {}, openToastChannel: () => {}, notifyChatOpen: () => {},
  reorderChannel: () => {}, sendReaction: () => {}, editMessage: () => {}, setNewMsg: () => {},
  readMap: {}, channelMemberCount: 0,
};

export function useChat() {
  return useContext(ChatContext) || EMPTY_CHAT;
}
